module.exports = __webpack_public_path__ + "static/img/y_bg.b01be4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/y_bg.jpg
// module id = O0rP
// module chunks = 1